import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DateSelectService {
  // private today: Date = new Date();
  analysisDate = ( d => new Date(d.setDate(d.getDate())) )(new Date);
  // private todayFormatted: string = String(this.today.getFullYear()) + "-" + String(this.today.getMonth() + 1).padStart(2, '0') + "-" + String(this.today.getDate()).padStart(2, '0');
  private analysisDateFormatted: string =
    String(this.analysisDate.getFullYear()) + "-" +
    String(this.analysisDate.getMonth() + 1).padStart(2, '0') + "-" +
    String(this.analysisDate.getDate()).padStart(2, '0');

  private dateSource = new BehaviorSubject<string>(this.analysisDateFormatted);
  currentDate = this.dateSource.asObservable();

  constructor() { }

  changeDate(date: string) {
    this.dateSource.next(date)
  }  
}
